'use strict';
(() => {
    class BasketToolbar {
        hide: boolean = false;
        basketTotal: number = 0;
        basketCount: number = 0;
        constructor(
            private $scope: ng.IScope,
            private attractionService,
            private basketStore,
            private broker)
        {
            basketStore.getAttractionsBasket()
                	.then(res => this.updateAttractionsBasket(res.LineItems));
            broker.subscribe('basketToolbarDirective', 'attractionsBasketUpdated',
                    e => this.updateAttractionsBasket(e.data && e.data.Basket && e.data.Basket.LineItems));
            broker.subscribe('basketToolbarDirective', 'basketCleared',
                    () => this.updateAttractionsBasket());

            $scope.$on('$destroy', () => {
                broker.unsubscribe('basketToolbarDirective');
            });
        }

        updateAttractionsBasket(lineItems?: any) : void {
            const totals = this.attractionService.getProductTotals(lineItems);
            this.basketTotal = totals.price;
            this.basketCount = totals.count;
        }
    }

    angular.module('TR')
        .directive('basketToolbar', ($rootScope: ng.IRootScopeService, broker: any): ng.IDirective => {
            return {
                restrict: 'E',
                controller: BasketToolbar,
                controllerAs: 'bt',
                replace: true,
                templateUrl: 'partials/home/directivetemplate?type=BasketToolbar',
                link: (scope: ng.IScope, el:JQuery, attr:ng.IAttributes, ctrl:BasketToolbar): void => {
                    $rootScope.$on('$routeChangeSuccess', function (_, next) {
                        ctrl.hide = !!next.hideDistractionLinks;
                    });
                }
            };
        });
})();
